import Vue from 'vue'
import Vuex from 'vuex'

import Account from "./Account";
import Alert from "./Alert";
import Asset from "./Asset";
import Authentication from "./Authentication";
import BankAccount from "./BankAccount";
import BatchDeposit from "./BatchDeposit";
import BatchPayment from "./BatchPayment";
import Bill from "./Bill";
import BillMaterial from "./BillMaterial";
import Brand from "./Brand";
import Chat from "./Chat";
import Claim from "./Claim";
import Company from "./Company";
import CreativeProject from "./CreativeProject";
import Country from "./Country";
import Currency from "./Currency";
import CurrencyRate from "./CurrencyRate";
import Customer from "./Customer";
import CustomerReport from "./CustomerReport";
import Department from "./Department";
import Deposit from "./Deposit";
import District from "./District";
import Employee from "./Employee";
import EmployeeFace from "./EmployeeFace";
import ExpenseReport from "./ExpenseReport";
import FinanceReport from "./FinanceReport";
import FixedAsset from "./FixedAsset";
import FABill from "./FABill";
import File from "./File";
import Geolocation from "./Geolocation";
import GLJournal from "./GLJournal";
import GLLedger from "./GLLedger";
import GLMap from "./GLMap";
import GLPost from "./GLPost";
import GLReport from "./GLReport";
import Holiday from "./Holiday";
import Image from "./Image";
import Invoice from "./Invoice";
import Inventory from "./Inventory";
import InventoryCount from "./InventoryCount";
import InventoryJournal from "./InventoryJournal";
import Item from "./Item";
import ItemGroup from "./ItemGroup";
import ItemCategory from "./ItemCategory";
import ItemSubcategory from "./ItemSubcategory";
import JobPosting from "./JobPosting";
import Layout from "./Layout";
import Language from "./Language";
import LoadingOrder from "./LoadingOrder";
import Location from "./Location";
import LocationTracking from "./LocationTracking";
import MarketAd from "./MarketAd";
import MarketCampaign from "./MarketCampaign";
import MarketContent from "./MarketContent";
import MarketDetail from "./MarketDetail";
import MarketMember from "./MarketMember";
import MarketPlatform from "./MarketPlatform";
import MarketPost from "./MarketPost";
import MarketProject from "./MarketProject";
import Material from "./Material";
import Menu from "./Menu";
import MyAccount from "./MyAccount";
import Payment from "./Payment";
import PayMethod from "./PayMethod";
import Payroll from "./Payroll";
import PayrollEntry from "./PayrollEntry";
import PayrollRecurring from "./PayrollRecurring";
import PayStatement from "./PayStatement";
import Policy from "./Policy";
import Price from "./Price";
import PriceList from "./PriceList";
import PrintApi from "./PrintApi";
import Promotion from "./Promotion";
import PurchaseOrder from "./PurchaseOrder";
import PurchaseReceipt from "./PurchaseReceipt";
import Qrcode from "./Qrcode";
import Region from "./Region";
import Reimbursement from "./Reimbursement";
import Request from "./Request";
import Role from "./Role";
import Route from "./Route";
import RoutePlan from "./RoutePlan";
import SalesChannel from "./SalesChannel";
import SalesRep from "./SalesRep";
import SalesCost from "./SalesCost";
import SalesOrder from "./SalesOrder";
import SalesReport from "./SalesReport";
import SalesSummary from "./SalesSummary";
import SalesTarget from "./SalesTarget";
import Search from "./Search";
import Shift from "./Shift";
import SystemSetting from "./SystemSetting";
import Team from "./Team";
import TimeTracking from "./TimeTracking";
import Township from "./Township";
import User from "./User";
import Vehicle from "./Vehicle";
import Vendor from "./Vendor";
import ViewApi from "./ViewApi";
import Visit from "./Visit";
import WebProject from "./WebProject";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Account,
    Alert,
    Asset,
    Authentication,
    BankAccount,
    BatchDeposit,
    BatchPayment,
    Bill,
    BillMaterial,
    Brand,
    Chat,
    Claim,
    Company,
    Country, 
    CreativeProject,
    Currency,
    CurrencyRate,
    Customer,
    CustomerReport,
    Department,
    Deposit,
    District,
    Employee,
    EmployeeFace,
    ExpenseReport,
    FinanceReport,
    FixedAsset,
    FABill,
    File,
    Geolocation,
    GLJournal,
    GLLedger,
    GLMap,
    GLPost,
    GLReport,
    Holiday,
    Image,
    Invoice,
    Inventory,
    InventoryCount,
    InventoryJournal,
    Item,
    ItemCategory,
    ItemGroup,
    ItemSubcategory,
    JobPosting,
    Language,
    Layout,
    LoadingOrder,
    Location,
    LocationTracking,
    MarketAd,
    MarketCampaign,
    MarketContent,
    MarketDetail,
    MarketMember,
    MarketPlatform,
    MarketPost,
    MarketProject,
    Material,
    Menu,
    MyAccount,
    Payment,
    PayMethod,
    Payroll,
    PayrollEntry,
    PayrollRecurring,
    PayStatement,
    Policy,
    Price,
    PriceList,
    PrintApi,
    Promotion,
    PurchaseOrder,
    PurchaseReceipt,
    Reimbursement,
    Qrcode,
    Region,
    Request,
    Role,
    Route,
    RoutePlan,
    SalesChannel,
    SalesRep,
    SalesCost,
    SalesOrder,
    SalesReport,
    SalesSummary,
    SalesTarget,
    Search,
    Shift,
    SystemSetting,
    Team,
    TimeTracking,
    Township,
    User,
    Vehicle,
    Vendor,
    ViewApi,
    Visit,
    WebProject,
  }
});
